import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  RiFolder2Line,
  RiCheckLine,
  RiCloseLine,
  RiIndeterminateCircleLine,
  RiFolderForbidLine,
} from 'react-icons/ri';
import { BsFileDiff } from 'react-icons/bs';
import Dropdown from '@hig/dropdown';
import lodashSortBy from 'lodash/sortBy';
import ProgressRing from '@hig/progress-ring';
import Button from '@hig/button';
import TextLink from '@hig/text-link';
import Flyout, { anchorPoints } from '@hig/flyout';
import { CloseSUI } from '@hig/icons';
import SchemaViewer from '../../components/SchemaValidationViewer/SchemaValidationViewer';
import { default as MatrixTable, Column, SortOrder } from '@adsk/bim360-matrix-react-matrix-table';
import { Breadcrumbs } from '@adsk/model-browser-react-components';
import { GitHubAPIHelper } from '../../data/api/github';
import {
  FSS_LIBRARY_PERMISSION_ADMIN,
  ForgeEnvironmentEnum,
  makeFetch,
  PermissionEnum,
  PublishStatusEnum,
  getNamespacePermission,
  setNamespacePermission,
  getPathPermission,
  mergePermissions,
  setSchemaPublishStatus,
  getSchemaPublishStatus,
  getSchemaIndexStatus,
  setSchemaIndexStatus,
  sortSchemas,
  delay,
  convertTypeidToPath,
  convertPathToTypeid,
  FSS_LIBRARY_PERMISSION_WRITE,
} from '../../data/api/utils';
import { URL_ADSK_GITHUB_URL } from '../../service/constants';
import settings from '../../settings/allowNamespaces';
import admins from '../../settings/allowUsers';
import { diff } from 'deep-diff';
import { GitHubItem } from '../../data/model/GitHubItem';

const columnDefinition = {
  name: {
    key: 'name',
    title: 'Name',
    groupKey: 'group0',
  },
  adminStaging: {
    key: 'admin_staging',
    title: 'Permission',
    groupKey: 'group1',
  },
  fssStaging: {
    key: 'stagingstatus',
    title: 'Publish Status',
    groupKey: 'group1',
  },
  indexStaging: {
    key: 'stagingindex',
    title: 'Index Status',
    groupKey: 'group1',
  },
  adminProduction: {
    key: 'admin_production',
    title: 'Permission',
    groupKey: 'group2',
  },
  fssProduction: {
    key: 'productionstatus',
    title: 'Publish Status',
    groupKey: 'group2',
  },
  indexProduction: {
    key: 'productionindex',
    title: 'Index Status',
    groupKey: 'group2',
  },
};

const columnGroups = [
  {
    key: 'group0',
    title: '',
  },
  {
    key: 'group1',
    title: 'FSS Staging',
  },
  {
    key: 'group2',
    title: 'FSS Production',
  },
];

const GitItemFilterEnum = Object.freeze({
  ALL: 'All',
  STAGING_ISSUES: 'Staging issues',
  PRODUCTION_ISSUES: 'Production issues',
  STAGING_UNKNOWN: 'Staging unknown',
  PRODUCTION_UNKNOWN: 'Production unknown',
});

const filters = [
  {
    item: GitItemFilterEnum.ALL,
    value: 0,
  },
  {
    item: GitItemFilterEnum.STAGING_ISSUES,
    value: 1,
  },
  {
    item: GitItemFilterEnum.PRODUCTION_ISSUES,
    value: 2,
  },
  {
    item: GitItemFilterEnum.STAGING_UNKNOWN,
    value: 3,
  },
  {
    item: GitItemFilterEnum.PRODUCTION_UNKNOWN,
    value: 4,
  },
];

export class GitHubRepositoryBrowser extends Component {
  state = {
    isLoading: true,
    items: [],
    tree: undefined,
    folderNavChain: [
      {
        name: 'autodesk',
        path: this.props.rootFolder,
        id: this.props.rootFolder,
        type: 'dir',
        stagingstatus: PublishStatusEnum.UNKNOWN,
        productionstatus: PublishStatusEnum.UNKNOWN,
        permission: PermissionEnum.UNKNOWN,
      },
    ],
    sort: {
      key: columnDefinition.name.key,
      order: SortOrder.ASC,
    },
    selection: {},
    currentFilterId: filters[0].item,
    filterFileName: undefined,
    filterIdsFromFile: [],
    showSchemaViewer: false,
    sourceJson: {},
    targetJsonStaging: {},
    targetJsonProduction: {},
    jsonDifferentStaging: undefined,
    jsonDifferentProduction: undefined,
    fssReport: undefined,
    error: {},
  };

  onHandleItemClick = (data) => {
    // console.log(data);
    if (data.type === 'dir') {
      this.setState({
        isLoading: true,
      });
      this.getItems(data.path)
        .then((items) => {
          const { folderNavChain } = this.state;
          folderNavChain.push(data);
          this.setState({ items, folderNavChain, isLoading: false, selection: {} });
        })
        .catch((err) => {
          this.setState({ ...this.state, error: err });
        });
    } else if (data.type === 'file') {
      this.getItemJson(data.path)
        .then((file) => {
          const schemaString = Buffer.from(file.content, 'base64').toString('utf8');
          const gitSchema = JSON.parse(schemaString);
          this.setState({
            sourceJson: gitSchema,
          });
          this.checkFSSStatus(data.path, schemaString)
            .then((result) => {
              let targetJsonProduction = {};
              let jsonDifferentProduction;
              let targetJsonStaging = {};
              let jsonDifferentStaging;
              if (result && Array.isArray(result)) {
                result.map((res) => {
                  if (res.env === ForgeEnvironmentEnum.STAGING) {
                    targetJsonStaging = res.schema;
                    jsonDifferentStaging = res.changes;
                  } else if (res.env === ForgeEnvironmentEnum.PRODUCTION) {
                    targetJsonProduction = res.schema;
                    jsonDifferentProduction = res.changes;
                  }
                });
              }
              this.setState({
                targetJsonStaging,
                jsonDifferentStaging,
                targetJsonProduction,
                jsonDifferentProduction,
                showSchemaViewer: true,
              });
            })
            .catch((err) => {
              throw err;
            });
        })
        .catch((err) => {
          this.setState({ error: err });
        });
    }
  };

  onHandleBreadcrumbClick = (item) => {
    this.setState({
      isLoading: true,
    });
    this.getItems(item.path)
      .then((items) => {
        const { folderNavChain } = this.state;
        const index = folderNavChain.findIndex((curItem) => curItem.path === item.path);
        if (index === -1) {
          return;
        }
        const newFolderNavChain = folderNavChain.slice(0, index + 1);
        this.setState({
          items,
          folderNavChain: newFolderNavChain,
          isLoading: false,
          selection: {},
        });
      })
      .catch((err) => {
        this.setState({ error: err });
      });
  };

  // callback is ({ rowData, rowIndex }) => bool
  onHandleSelectable = (selectedData) => {
    // we only support file selection.
    return selectedData.rowData.path.indexOf('.json') >= 0;
  };

  _handleSelectAll = (selected, selectedRowKeys) => {
    const selection = {};
    const selectedFileKeys = selectedRowKeys.filter((key) => key.indexOf('.json') >= 0);
    const selectedFiles = this.state.items
      .filter((item) => item.type === 'file')
      .filter((item) => {
        if (
          this.state.currentFilterId === GitItemFilterEnum.STAGING_ISSUES &&
          item.stagingstatus !== PublishStatusEnum.PUBLISHED
        ) {
          return true;
        } else if (
          this.state.currentFilterId === GitItemFilterEnum.PRODUCTION_ISSUES &&
          item.productionstatus !== PublishStatusEnum.PUBLISHED
        ) {
          return true;
        } else if (this.state.currentFilterId === GitItemFilterEnum.ALL) {
          return true;
        } else {
          return false;
        }
      });
    if (selected && selectedFileKeys.length === selectedFiles.length) {
      selectedFiles.forEach((i) => {
        selection[i.path] = i;
      });
    }
    this.setState({
      selection,
    });
  };

  onItemSelected = (selected, rowData) => {
    const selection = { ...this.state.selection };
    // console.log(selected);
    // console.log(rowData);
    if (selection[rowData.path] === undefined && selected) {
      selection[rowData.path] = rowData;
    } else if (selection[rowData.path] !== undefined && !selected) {
      delete selection[rowData.path];
    } else {
      throw new Error(`${rowData.path}'s selection status is ${selected}`);
    }
    this.setState({
      selection,
    });
  };

  _handleExitSchemaViewer = () => {
    this.setState({
      showSchemaViewer: false,
      targetJsonStaging: {},
      targetJsonProduction: {},
      jsonDifferentStaging: undefined,
      jsonDifferentProduction: undefined,
    });
  };

  _handleGetFSSStatusReport = () => {
    if (localStorage.FSSStgStatus === undefined) {
      return;
    }
    const fssStatus = JSON.parse(localStorage.FSSStgStatus);
    const pathes = Object.keys(fssStatus);
    const result = [];
    pathes.forEach((p) => {
      const ns = p.substring(p.indexOf('/') + 1, p.lastIndexOf('/')).replace(/\//g, '.');
      if (
        this.isNamespaceInAllowList(ns) &&
        (fssStatus[p].staging === PublishStatusEnum.NOT_PUBLISHED ||
          fssStatus[p].staging === PublishStatusEnum.SCHEMA_DIFFERENT)
      ) {
        result.push({
          path: p,
          staging: fssStatus[p].staging,
        });
      }
    });

    this.setState({
      fssReport: result,
    });
  };

  _handleSelection = () => {
    if (Object.keys(this.state.selection).length > 0) {
      this.setState({
        selection: {},
      });
    } else {
      const selection = {};
      const selectedFiles = this._handleSort(
        this.state.items.filter((item) => item.type === 'file'),
        this.state.sort
      ).slice(0, 100);
      selectedFiles.forEach((i) => {
        selection[i.path] = i;
      });
      this.setState({
        selection,
      });
    }
  };

  checkFSSStatus = (path, schemaString) => {
    const gitSchema = JSON.parse(schemaString);
    const typeId = gitSchema.typeid;

    const promises = [];
    [ForgeEnvironmentEnum.STAGING, ForgeEnvironmentEnum.PRODUCTION].map((env) => {
      promises.push(
        makeFetch('', `${env}/versions/propertySets:${typeId}`)
          .then((schema) => {
            // console.log(schema);
            const fssSchema = schema.schema;
            const changes = diff.diff(gitSchema, fssSchema);

            const itemIndex = this.state.items.findIndex((v) => v.path === path);
            const item = { ...this.state.items[itemIndex] };
            if (env === ForgeEnvironmentEnum.STAGING) {
              item.stagingstatus = changes
                ? PublishStatusEnum.SCHEMA_DIFFERENT
                : PublishStatusEnum.PUBLISHED;
              setSchemaPublishStatus(env, path, item.stagingstatus);
            } else {
              item.productionstatus = changes
                ? PublishStatusEnum.SCHEMA_DIFFERENT
                : PublishStatusEnum.PUBLISHED;
              setSchemaPublishStatus(env, path, item.productionstatus);
            }
            const items = [
              ...this.state.items.slice(0, itemIndex),
              item,
              ...this.state.items.slice(itemIndex + 1),
            ];
            this.setState({
              items,
            });
            return {
              typeId,
              env,
              schema: fssSchema,
              changes,
            };
          })
          .catch((err) => {
            // console.log(err);
            const itemIndex = this.state.items.findIndex((v) => v.path === path);
            const item = { ...this.state.items[itemIndex] };
            if (env === ForgeEnvironmentEnum.STAGING) {
              item.stagingstatus = PublishStatusEnum.NOT_PUBLISHED;
              setSchemaPublishStatus(env, path, item.stagingstatus);
            } else {
              item.productionstatus = PublishStatusEnum.NOT_PUBLISHED;
              setSchemaPublishStatus(env, path, item.productionstatus);
            }
            const items = [
              ...this.state.items.slice(0, itemIndex),
              item,
              ...this.state.items.slice(itemIndex + 1),
            ];
            this.setState({
              items,
              error: err,
            });
            return {
              typeId,
              env,
              schema: {},
              changes: undefined,
            };
          })
      );
    });
    return Promise.all(promises);
  };

  _handleCheckFSSStatus = () => {
    // console.log(this.state.selection);
    const pathes = Object.keys(this.state.selection);

    // update the status to "updating".
    const arrIndex = [];
    pathes.forEach((path) => {
      const itemIndex = this.state.items.findIndex((v) => v.path === path);
      if (itemIndex >= 0) {
        arrIndex.push(itemIndex);
      }
    });

    let items = [...this.state.items];
    arrIndex.forEach((i) => {
      const item = { ...items[i] };
      item.stagingstatus = PublishStatusEnum.UPDATING;
      item.stagingindex = PublishStatusEnum.UPDATING;
      item.productionstatus = PublishStatusEnum.UPDATING;
      item.productionindex = PublishStatusEnum.UPDATING;
      items = [...items.slice(0, i), item, ...items.slice(i + 1)];
    });
    this.setState({
      items,
    });

    pathes.forEach((path) => {
      this.getItemJson(path)
        .then((file) => {
          const schemaString = Buffer.from(file.content, 'base64').toString('utf8');
          this.checkFSSStatus(path, schemaString);
        })
        .catch((err) => {
          this.setState({ error: err });
        });
    });
  };

  _handlePublishSchema = (env) => () => {
    // console.warn(env);
    const paths = Object.keys(this.state.selection);
    // update the status to "updating".
    let items = this.state.items;
    paths.forEach((path) => {
      const itemIndex = items.findIndex((v) => v.path === path);
      if (itemIndex >= 0) {
        const item = { ...items[itemIndex] };
        if (env === ForgeEnvironmentEnum.STAGING) {
          item.stagingstatus = PublishStatusEnum.UPDATING;
        } else {
          item.productionstatus = PublishStatusEnum.UPDATING;
        }
        items = [...items.slice(0, itemIndex), item, ...items.slice(itemIndex + 1)];
      }
    });
    this.setState({
      items,
    });

    // upload the schemas to fss.
    // 1. collect schemas
    const promises = [];
    paths.forEach((path) => {
      promises.push(
        this.getItemJson(path).then((file) => {
          const schemaString = Buffer.from(file.content, 'base64').toString('utf8');
          const schema = JSON.parse(schemaString);
          return schema;
        })
      );
    });

    // 2. bulkUpload.
    Promise.all(promises)
      .then(async (schemas) => {
        const sortedSchemas = sortSchemas(schemas);
        for (let i = 0; i < sortedSchemas.length; i++) {
          delay(2000);
          const options = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            // mode: 'cors', // no-cors, *cors, same-origin
            // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            // credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              data: {
                schema: sortedSchemas[i],
              },
            }),
          };
          const typeid = sortedSchemas[i].typeid;
          const path = convertTypeidToPath(typeid);
          await makeFetch('', `${env}/versions`, options)
            .then((result) => {
              // console.log(d);
              let d = result;
              if (typeof result === 'string') {
                d = JSON.parse(result);
              }
              if (d !== undefined) {
                const itemIndex = this.state.items.findIndex((v) => v.path === path);
                if (itemIndex >= 0) {
                  const item = { ...this.state.items[itemIndex] };
                  if (env === ForgeEnvironmentEnum.STAGING) {
                    item.stagingstatus = PublishStatusEnum.PUBLISHED;
                    setSchemaPublishStatus(ForgeEnvironmentEnum.STAGING, path, item.stagingstatus);
                  } else {
                    item.productionstatus = PublishStatusEnum.PUBLISHED;
                    setSchemaPublishStatus(
                      ForgeEnvironmentEnum.PRODUCTION,
                      path,
                      item.productionstatus
                    );
                  }
                  const items = [
                    ...this.state.items.slice(0, itemIndex),
                    item,
                    ...this.state.items.slice(itemIndex + 1),
                  ];
                  this.setState({ items });
                }
                // alert('Published!');
              }
            })
            .catch((err) => {
              const itemIndex = this.state.items.findIndex((v) => v.path === path);
              if (itemIndex >= 0) {
                const item = { ...this.state.items[itemIndex] };
                if (env === ForgeEnvironmentEnum.STAGING) {
                  item.stagingstatus = PublishStatusEnum.NOT_PUBLISHED;
                  setSchemaPublishStatus(ForgeEnvironmentEnum.STAGING, path, item.stagingstatus);
                } else {
                  item.productionstatus = PublishStatusEnum.NOT_PUBLISHED;
                  setSchemaPublishStatus(
                    ForgeEnvironmentEnum.PRODUCTION,
                    path,
                    item.productionstatus
                  );
                }
                const items = [
                  ...this.state.items.slice(0, itemIndex),
                  item,
                  ...this.state.items.slice(itemIndex + 1),
                ];
                this.setState({ error: err, items });
              }
            });
        }
      })
      .catch((error) => {
        this.setState({ error });
      });
  };

  _handleIndexSchema = (env) => () => {
    const paths = Object.keys(this.state.selection);
    // update the status to "updating".
    let items = this.state.items;
    paths.forEach((path) => {
      const itemIndex = items.findIndex((v) => v.path === path);
      if (itemIndex >= 0) {
        const item = { ...items[itemIndex] };
        if (env === ForgeEnvironmentEnum.STAGING) {
          item.stagingindex = PublishStatusEnum.UPDATING;
        } else {
          item.productionindex = PublishStatusEnum.UPDATING;
        }
        items = [...items.slice(0, itemIndex), item, ...items.slice(itemIndex + 1)];
      }
    });
    this.setState({
      items,
    });

    // index the schemas to fss.
    // 1. collect schemas
    const promises = [];
    paths.forEach((path) => {
      promises.push(
        this.getItemJson(path).then((file) => {
          const schemaString = Buffer.from(file.content, 'base64').toString('utf8');
          const schema = JSON.parse(schemaString);
          return schema;
        })
      );
    });

    // 2. index schemas.
    Promise.all(promises)
      .then((schemas) => {
        const indexRequests = [];
        for (let i = 0; i < schemas.length; i++) {
          const options = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              data: {
                schema: schemas[i],
              },
            }),
          };
          const typeid = schemas[i].typeid;
          const path = convertTypeidToPath(typeid);
          indexRequests.push(
            makeFetch('', `${env}/versions/${typeid}/index`, options)
              .then((result) => {
                // console.log(d);
                const d = result;
                if (
                  d.data !== undefined &&
                  d.data.attributes !== undefined &&
                  d.data.attributes.schema !== undefined
                ) {
                  const itemIndex = this.state.items.findIndex((v) => v.path === path);
                  if (itemIndex >= 0) {
                    const item = { ...this.state.items[itemIndex] };
                    if (env === ForgeEnvironmentEnum.STAGING) {
                      item.stagingindex = PublishStatusEnum.PUBLISHED;
                      setSchemaIndexStatus(ForgeEnvironmentEnum.STAGING, path, item.stagingindex);
                    } else {
                      item.productionindex = PublishStatusEnum.PUBLISHED;
                      setSchemaIndexStatus(
                        ForgeEnvironmentEnum.PRODUCTION,
                        path,
                        item.productionindex
                      );
                    }
                    const items = [
                      ...this.state.items.slice(0, itemIndex),
                      item,
                      ...this.state.items.slice(itemIndex + 1),
                    ];
                    this.setState({ items });
                  }
                }
              })
              .catch((err) => {
                const itemIndex = this.state.items.findIndex((v) => v.path === path);
                if (itemIndex >= 0) {
                  const item = { ...this.state.items[itemIndex] };
                  if (env === ForgeEnvironmentEnum.STAGING) {
                    item.stagingindex = PublishStatusEnum.NOT_PUBLISHED;
                    setSchemaIndexStatus(ForgeEnvironmentEnum.STAGING, path, item.stagingindex);
                  } else {
                    item.productionindex = PublishStatusEnum.NOT_PUBLISHED;
                    setSchemaIndexStatus(
                      ForgeEnvironmentEnum.PRODUCTION,
                      path,
                      item.productionindex
                    );
                  }
                  const items = [
                    ...this.state.items.slice(0, itemIndex),
                    item,
                    ...this.state.items.slice(itemIndex + 1),
                  ];
                  this.setState({ ...this.state, error: err, items });
                }
              })
          );
        }
        return Promise.all(indexRequests);
      })
      .catch((error) => {
        this.setState({ ...this.state, error });
      });
  };

  isNamespaceInAllowList = (ns) => {
    if (ns === undefined || typeof ns !== 'string') {
      return false;
    } else {
      return settings.allow.find((n) => ns.indexOf(n) > -1) !== undefined;
    }
  };

  renderNameCell = ({ rowData }) => {
    const isFolder = rowData.type === 'dir';
    const path = rowData.path;
    let ns = 'autodesk';
    if (isFolder) {
      ns = path.substring(path.indexOf('/') + 1).replace(/\//g, '.');
    } else {
      ns = path.substring(path.indexOf('/') + 1, path.lastIndexOf('/')).replace(/\//g, '.');
    }
    const isAllToUpload = this.isNamespaceInAllowList(ns);
    return (
      <div className="itemcell" key={rowData.path}>
        {isFolder &&
          (isAllToUpload ? (
            <RiFolder2Line className="itemicon" />
          ) : (
            <RiFolderForbidLine className="itemicon" />
          ))}
        <TextLink
          onClick={() => {
            this.onHandleItemClick(rowData);
          }}
        >
          {rowData.name}
        </TextLink>
      </div>
    );
  };

  renderRoleCell = (cellData) => {
    const thisUserId = this.props.userId;
    let permission = PermissionEnum.SCHEMA_READER;
    let adminPermissions = [];
    let writePermissions = [];
    if (cellData.column.key === columnDefinition.adminStaging.key) {
      adminPermissions = cellData.rowData.stagingpermission.find(
        (p) => p.role === FSS_LIBRARY_PERMISSION_ADMIN
      );
      writePermissions = cellData.rowData.stagingpermission.find(
        (p) => p.role === FSS_LIBRARY_PERMISSION_WRITE
      );
    } else if (cellData.column.key === columnDefinition.adminProduction.key) {
      adminPermissions = cellData.rowData.productionpermission.find(
        (p) => p.role === FSS_LIBRARY_PERMISSION_ADMIN
      );
      writePermissions = cellData.rowData.productionpermission.find(
        (p) => p.role === FSS_LIBRARY_PERMISSION_WRITE
      );
    }
    if (
      adminPermissions &&
      adminPermissions.subjects &&
      adminPermissions.subjects.o2Users &&
      Array.isArray(adminPermissions.subjects.o2Users) &&
      adminPermissions.subjects.o2Users.includes(thisUserId)
    ) {
      permission = PermissionEnum.NAMESPACE_ADMIN;
    }
    if (
      writePermissions &&
      writePermissions.subjects &&
      writePermissions.subjects.o2Users &&
      Array.isArray(writePermissions.subjects.o2Users) &&
      writePermissions.subjects.o2Users.includes(thisUserId)
    ) {
      permission = PermissionEnum.SCHEMA_AUTHOR;
    }
    switch (permission) {
      case PermissionEnum.UNKNOWN:
        return (
          <div key={cellData.column.dataKey + cellData.rowData.path}>
            <ProgressRing size="xs" />
          </div>
        );
      case PermissionEnum.NAMESPACE_ADMIN:
        return <p>Admin</p>;
      case PermissionEnum.SCHEMA_AUTHOR:
        return <p>Write</p>;
      case PermissionEnum.SCHEMA_READER:
        return <p>Read</p>;
      case PermissionEnum.NOT_EXIST:
        return <p>This namespace is not exist!</p>;
      default:
        return <p>Unknown</p>;
    }
  };

  renderStatusCell = (cellData) => {
    let publishStatus = PublishStatusEnum.UNKNOWN;
    switch (cellData.column.dataKey) {
      case 'stagingstatus':
        publishStatus = cellData.rowData.stagingstatus;
        break;
      case 'stagingindex':
        publishStatus = cellData.rowData.stagingindex;
        break;
      case 'productionstatus':
        publishStatus = cellData.rowData.productionstatus;
        break;
      case 'productionindex':
        publishStatus = cellData.rowData.productionindex;
        break;
      default:
        break;
    }
    if (publishStatus === PublishStatusEnum.UNKNOWN) {
      return (
        <div key={cellData.column.dataKey + cellData.rowData.path}>
          <RiIndeterminateCircleLine />
        </div>
      );
    } else if (publishStatus === PublishStatusEnum.PUBLISHED) {
      return (
        <div key={cellData.column.dataKey + cellData.rowData.path}>
          <RiCheckLine className="info" />
        </div>
      );
    } else if (publishStatus === PublishStatusEnum.NOT_PUBLISHED) {
      return (
        <div key={cellData.column.dataKey + cellData.rowData.path}>
          <RiCloseLine className="error" />
        </div>
      );
    } else if (publishStatus === PublishStatusEnum.SCHEMA_DIFFERENT) {
      return (
        <div key={cellData.column.dataKey + cellData.rowData.path}>
          <BsFileDiff className="error" />
        </div>
      );
    } else if (publishStatus === PublishStatusEnum.UPDATING) {
      return (
        <div key={cellData.column.dataKey + cellData.rowData.path}>
          <ProgressRing size="xs" />
        </div>
      );
    } else {
      return (
        <div key={cellData.column.dataKey + cellData.rowData.path}>
          <ProgressRing size="xs" />
        </div>
      );
    }
  };

  renderBreadcrumb = () => {
    const { folderNavChain, items, selection } = this.state;
    const itemsTotal = items.length;
    const selectedRowKeys = Object.values(selection).map((v) => v.name);
    const selectedCount = selectedRowKeys.length;
    const filteredItems = this._handleSort(items, this.state.sort);
    return (
      <>
        <Breadcrumbs
          items={folderNavChain}
          onClick={(item) => this.onHandleBreadcrumbClick(item)}
          icon={<RiFolder2Line className="itemicon" />}
          hidden={!(folderNavChain && folderNavChain.length > 1)}
        />
        <span className="statistic">{`selected ${selectedCount} in filtered ${filteredItems.length} of totall ${itemsTotal} schema`}</span>
      </>
    );
  };

  _handleClickOutside = () => {};

  _handleScroll = () => {};

  renderToolbar = () => {
    const { selection } = this.state;
    const selectedPathes = Object.keys(selection);
    const currentUserEmail = this.props.userEmail;
    const isAdmin = admins.includes(currentUserEmail);
    const noNeedPublishToStaging =
      this.state.items.filter(
        (i) =>
          selectedPathes.indexOf(i.path) >= 0 && i.stagingstatus === PublishStatusEnum.NOT_PUBLISHED
      ).length < 1;
    const noNeedPublishToProduction =
      this.state.items.filter(
        (i) =>
          selectedPathes.indexOf(i.path) >= 0 &&
          i.productionstatus === PublishStatusEnum.NOT_PUBLISHED
      ).length < 1;
    return (
      <div>
        <Flyout
          className="report"
          content={({ hideFlyout }) => {
            const { fssReport } = this.state;
            const fssReportContent =
              fssReport === undefined ? (
                <p>No report! Please check the status first.</p>
              ) : (
                <ul>
                  {fssReport.map((item) => {
                    let icon = <BsFileDiff className="error" />;
                    if (item.staging === PublishStatusEnum.NOT_PUBLISHED) {
                      icon = <RiCloseLine className="error" />;
                    }
                    return (
                      <li key={item.path}>
                        {icon}
                        {item.path}
                      </li>
                    );
                  })}
                </ul>
              );
            return (
              <div>
                {fssReportContent}
                <button type="button" onClick={hideFlyout}>
                  Click to hide
                </button>
              </div>
            );
          }}
          anchorPoint={anchorPoints.TOP_LEFT}
          onClickOutside={this._handleClickOutside}
          onScroll={this._handleScroll}
        >
          <Button title="Report" onClick={this._handleGetFSSStatusReport} />
        </Flyout>
        <Button
          size="standard"
          title="Select 100 items"
          type="primary"
          onClick={this._handleSelection}
        />
        <Button
          size="standard"
          title="Check FSS Status"
          type="primary"
          onClick={this._handleCheckFSSStatus}
        />
        <Button
          size="standard"
          title="Publish to FSS Staging"
          type="primary"
          onClick={this._handlePublishSchema(ForgeEnvironmentEnum.STAGING)}
          disabled={noNeedPublishToStaging || !isAdmin}
        />
        <Button
          size="standard"
          title="Publish to FSS Production"
          type="primary"
          onClick={this._handlePublishSchema(ForgeEnvironmentEnum.PRODUCTION)}
          disabled={noNeedPublishToProduction || !isAdmin}
        />
      </div>
    );
  };

  _handleFilterChange = (filterId) => {
    this.setState({ ...this.state, currentFilterId: filterId });
  };

  _handleOnChangeFilterFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (event.target.files === undefined || event.target.files.length < 1) {
      return;
    }
    this._handeOnFilterFile(event.target.files[0]);
  };

  _handeOnFilterFile = (file) => {
    const fileName = file.name;
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    const fileNameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
    if (extension === 'csv') {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target.result;
        const ids = text.split(',').map((s) => s.trim());
        this.setState({
          ...this.state,
          filterFileName: fileNameWithoutExt,
          filterIdsFromFile: ids,
        });
      };
      reader.readAsText(file);
    }
  };

  renderToolbar2 = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', height: '44px' }}>
        <h4>Filters - </h4>
        <form
          id="a_form"
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '200px',
            marginLeft: '10px',
          }}
        >
          <Dropdown
            placeholder=""
            value={this.state.currentFilterId}
            options={filters}
            onChange={this._handleFilterChange}
          />
        </form>
        <Button
          size="standard"
          type="primary"
          on={false}
          onClick={() => {
            this._upload.click();
          }}
          title={'Filter from a file'}
        />
        <input
          id="file-input"
          ref={(ref) => (this._upload = ref)}
          style={{ display: 'none' }}
          onChange={this._handleOnChangeFilterFile}
          onClick={() => {
            this._upload.value = null;
          }}
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          name="name"
        />
        {this.state.filterFileName && (
          <Button
            type="outline"
            icon={<CloseSUI />}
            title={this.state.filterFileName}
            onClick={() =>
              this.setState({ ...this.state, filterFileName: undefined, filterIdsFromFile: [] })
            }
          />
        )}
      </div>
    );
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.getTree()
      .then((result) => {
        if (result && result.data) {
          this.setState({ tree: result.data });
        }
      })
      .then(() => {
        this.getItems(this.props.rootFolder)
          .then((items) => {
            this.setState({
              items,
              isLoading: false,
            });
          })
          .catch((err) => {
            this.setState({ ...this.state, error: err });
          });
      })
      .catch((err) => {
        this.setState({ ...this.state, error: err });
      });
  }

  getItemJson = (path) => {
    const gitHubAPIHelper = new GitHubAPIHelper(
      URL_ADSK_GITHUB_URL,
      this.props.repositoryName,
      this.props.repositoryOwner
    );
    return gitHubAPIHelper
      .getContent(path)
      .then((res) => {
        // console.log(content);
        if (res.data.name.includes('.json')) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((err) => {
        this.setState({ ...this.state, error: err });
      });
  };

  getTree = () => {
    const gitHubAPIHelper = new GitHubAPIHelper(
      URL_ADSK_GITHUB_URL,
      this.props.repositoryName,
      this.props.repositoryOwner,
      this.props.branchName
    );
    return gitHubAPIHelper.getTree();
  };

  getItems = (path) => {
    return new Promise((resolve) => {
      const items = [];
      this.state.tree.tree
        .filter((item) => item.path.indexOf(path) === 0)
        .forEach((i) => {
          let type = 'file';
          if (i.type === 'tree') {
            type = 'dir';
          }
          const name = i.path.substr(path.length + 1);
          if (
            name.length > 0 &&
            name.indexOf('/') < 0 &&
            (type === 'dir' || name.indexOf('-') >= 0)
          ) {
            const stagingstatus = getSchemaPublishStatus(ForgeEnvironmentEnum.STAGING, i.path);
            const productionstatus = getSchemaPublishStatus(
              ForgeEnvironmentEnum.PRODUCTION,
              i.path
            );
            const stagingindex = getSchemaIndexStatus(ForgeEnvironmentEnum.STAGING, i.path);
            const productionindex = getSchemaIndexStatus(ForgeEnvironmentEnum.PRODUCTION, i.path);
            items.push(
              new GitHubItem(
                name,
                i.path,
                type,
                stagingstatus,
                productionstatus,
                stagingindex,
                productionindex
              )
            );
          }
        });
      resolve(items);
    })
      .then((items) => {
        // checks the roles of this namespace.
        const promises = [];
        promises.push(items); // first item is orignal items, and the rest are promises to fetch permission.
        items.forEach((i) => {
          // checks the role of this namespace.
          if (i.type === 'dir') {
            const namespaceId =
              'autodesk' + i.path.substring(this.props.rootFolder.length).replace(/\//g, '.');
            // console.log(namespaceId);
            // get the staging permissions.
            [ForgeEnvironmentEnum.STAGING, ForgeEnvironmentEnum.PRODUCTION].map((env) => {
              const folderPermission = getNamespacePermission(env, namespaceId);
              if (
                folderPermission &&
                Array.isArray(folderPermission) &&
                folderPermission.length > 0
              ) {
                if (env === ForgeEnvironmentEnum.STAGING) i.stagingpermission = folderPermission;
                else i.productionpermission = folderPermission;
              }

              promises.push(
                makeFetch('', `/${env}/namespaces/${namespaceId}`)
                  .then((ns) => {
                    return {
                      id: i.path,
                      permission: ns.attributes.permissions || [],
                      request: env,
                    };
                  })
                  .catch((err) => {
                    // console.log(err);
                    this.setState({ ...this.state, error: err });
                    return {
                      id: i.path,
                      permission: [],
                      request: env,
                    };
                  })
              );
            });
          } else {
            i.stagingpermission = getPathPermission(ForgeEnvironmentEnum.STAGING, i.path);
            i.productionpermission = getPathPermission(ForgeEnvironmentEnum.PRODUCTION, i.path);
          }
        });
        return Promise.all(promises);
      })
      .then((items) => {
        // merge the items as we might send requests to both staging and production.
        const result = items[0];
        for (let i = 1; i < items.length; i++) {
          const res = items[i];
          const foundIt = result.find((i) => i.id === res.id);
          if (foundIt) {
            if (res.request === ForgeEnvironmentEnum.STAGING) {
              foundIt.stagingpermission = mergePermissions(
                foundIt.stagingpermission,
                res.permission || []
              );
              setNamespacePermission(res.request, res.id, foundIt.stagingpermission);
            } else {
              foundIt.productionpermission = mergePermissions(
                foundIt.productionpermission,
                res.permission || []
              );
              setNamespacePermission(res.request, res.id, foundIt.productionpermission);
            }
          }
        }
        return result;
      })
      .catch((err) => {
        this.setState({ ...this.state, error: err });
      });
  };

  sortKeyGenerator = (rowdata, sort) => {
    const sortKey = rowdata[sort.key];
    if (!sortKey) {
      return '';
    }
    return sortKey.toString().toLowerCase();
  };

  _handleSort = (data, sort) => {
    if (!data) {
      return [];
    }
    let folders = data.filter((rowData) => rowData.type === 'dir');
    if (sort.key === 'name') {
      folders = lodashSortBy(folders, (x) => this.sortKeyGenerator(x, sort));
      if (sort.order === SortOrder.DESC) {
        folders.reverse();
      }
    }

    const { currentFilterId, filterFileName, filterIdsFromFile } = this.state;
    let items = data.filter((rowData) => rowData.type === 'file');
    if (currentFilterId === GitItemFilterEnum.STAGING_ISSUES) {
      items = items.filter((rowData) => rowData.stagingstatus !== PublishStatusEnum.PUBLISHED);
    } else if (currentFilterId === GitItemFilterEnum.PRODUCTION_ISSUES) {
      items = items.filter((rowData) => rowData.productionstatus !== PublishStatusEnum.PUBLISHED);
    } else if (currentFilterId === GitItemFilterEnum.STAGING_UNKNOWN) {
      items = items.filter((rowData) => rowData.stagingstatus === PublishStatusEnum.UNKNOWN);
    } else if (currentFilterId === GitItemFilterEnum.PRODUCTION_UNKNOWN) {
      items = items.filter((rowData) => rowData.productionstatus === PublishStatusEnum.UNKNOWN);
    }
    if (filterFileName && filterIdsFromFile.length > 0) {
      items = items.filter(
        (rowData) => filterIdsFromFile.indexOf(convertPathToTypeid(rowData.path)) >= 0
      );
    }
    items = lodashSortBy(items, (x) => this.sortKeyGenerator(x, sort));
    if (sort.order === SortOrder.DESC) {
      items.reverse();
    }

    return folders.concat(items);
  };

  _handleColumnSort = (sort) => {
    this.setState({ sort });
  };

  render() {
    const {
      items,
      isLoading,
      showSchemaViewer,
      sourceJson,
      targetJsonStaging,
      targetJsonProduction,
      jsonDifferentStaging,
      jsonDifferentProduction,
      selection,
    } = this.state;
    const selectedRowKeys = Object.values(selection).map((v) => v.name);
    return (
      <>
        <div className="browser">
          <h2>Welcome to Raw Schema (GitHub - {this.props.repositoryName}) Browser</h2>
          <div className="toolbar">{this.renderToolbar()}</div>
          <div className="toolbar">{this.renderToolbar2()}</div>
          <div className="breadcrumb">{this.renderBreadcrumb()}</div>
          <div className="table">
            <MatrixTable
              fixed
              selectable={this.onHandleSelectable}
              sortBy={this.state.sort}
              onSelectAll={this._handleSelectAll}
              selectedRowKeys={selectedRowKeys}
              onColumnSort={this._handleColumnSort}
              onRowSelect={({ selected, rowData }) => this.onItemSelected(selected, rowData)}
              rowKey={'name'}
              data={this._handleSort(items, this.state.sort)}
              loading={isLoading}
              showSettings
              columnGroups={columnGroups}
              headerGroupHeight={25}
            >
              <Column
                title={columnDefinition.name.title}
                key={columnDefinition.name.key}
                dataKey={columnDefinition.name.key}
                disableTooltip={true}
                width={400}
                minWidth={200}
                sortable
                resizable
                cellRenderer={this.renderNameCell}
                groupKey={columnDefinition.name.groupKey}
              />
              <Column
                title={columnDefinition.adminStaging.title}
                key={columnDefinition.adminStaging.key}
                dataKey={columnDefinition.adminStaging.key}
                disableTooltip={true}
                width={200}
                minWidth={100}
                sortable
                resizable
                cellRenderer={this.renderRoleCell}
                groupKey={columnDefinition.adminStaging.groupKey}
              />
              <Column
                title={columnDefinition.fssStaging.title}
                key={columnDefinition.fssStaging.key}
                dataKey={columnDefinition.fssStaging.key}
                disableTooltip={true}
                width={120}
                minWidth={100}
                sortable
                resizable
                cellRenderer={this.renderStatusCell}
                groupKey={columnDefinition.fssStaging.groupKey}
              />
              <Column
                title={columnDefinition.adminProduction.title}
                key={columnDefinition.adminProduction.key}
                dataKey={columnDefinition.adminProduction.key}
                disableTooltip={true}
                width={200}
                minWidth={100}
                sortable
                resizable
                cellRenderer={this.renderRoleCell}
                groupKey={columnDefinition.adminProduction.groupKey}
              />
              <Column
                title={columnDefinition.fssProduction.title}
                key={columnDefinition.fssProduction.key}
                dataKey={columnDefinition.fssProduction.key}
                disableTooltip={true}
                width={120}
                minWidth={100}
                sortable
                resizable
                cellRenderer={this.renderStatusCell}
                groupKey={columnDefinition.fssProduction.groupKey}
              />
            </MatrixTable>
          </div>
        </div>
        {showSchemaViewer && (
          <SchemaViewer
            open={showSchemaViewer}
            targetJsonStaging={targetJsonStaging}
            targetJsonProduction={targetJsonProduction}
            jsonDifferentStaging={jsonDifferentStaging}
            jsonDifferentProduction={jsonDifferentProduction}
            sourceJson={sourceJson}
            onExited={this._handleExitSchemaViewer}
          />
        )}
      </>
    );
  }
}

GitHubRepositoryBrowser.propTypes = {
  token: PropTypes.string,
  userId: PropTypes.string,
  userEmail: PropTypes.string,
  repositoryName: PropTypes.string.isRequired,
  repositoryOwner: PropTypes.string.isRequired,
  branchName: PropTypes.string.isRequired,
  rootFolder: PropTypes.string.isRequired,
};

export default GitHubRepositoryBrowser;
